/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AbpPtwExceptionHttpResponseModel,
  AvailableUpdateUpgradeResponseDto,
  RunUpdateUpgradeRequestDto,
  UpdateUpgradeStartResponseDto,
  UpdateUpgradeStatusDto,
} from '../models/index';
import {
    AbpPtwExceptionHttpResponseModelFromJSON,
    AbpPtwExceptionHttpResponseModelToJSON,
    AvailableUpdateUpgradeResponseDtoFromJSON,
    AvailableUpdateUpgradeResponseDtoToJSON,
    RunUpdateUpgradeRequestDtoFromJSON,
    RunUpdateUpgradeRequestDtoToJSON,
    UpdateUpgradeStartResponseDtoFromJSON,
    UpdateUpgradeStartResponseDtoToJSON,
    UpdateUpgradeStatusDtoFromJSON,
    UpdateUpgradeStatusDtoToJSON,
} from '../models/index';

export interface RunUpdateUpgradeRequest {
    runUpdateUpgradeRequestDto?: RunUpdateUpgradeRequestDto;
}

/**
 * 
 */
export class PtwEdgeUpdateApi extends runtime.BaseAPI {

    /**
     */
    async checkForNewUpdatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AvailableUpdateUpgradeResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/ptwedge-update`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => AvailableUpdateUpgradeResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async checkForNewUpdates(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.checkForNewUpdatesRaw(initOverrides);
        return this.configuration.handleFunction<AvailableUpdateUpgradeResponseDto>(response, errorHandlers);
    }

    /**
     */
    async runUpdateUpgradeRaw(requestParameters: RunUpdateUpgradeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateUpgradeStartResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/ptwedge-update/start-update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RunUpdateUpgradeRequestDtoToJSON(requestParameters.runUpdateUpgradeRequestDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateUpgradeStartResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async runUpdateUpgrade(requestParameters: RunUpdateUpgradeRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.runUpdateUpgradeRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<UpdateUpgradeStartResponseDto>(response, errorHandlers);
    }

    /**
     */
    async syncUpdateUpgradeStateRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateUpgradeStatusDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/ptwedge-update/sync-state`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateUpgradeStatusDtoFromJSON(jsonValue));
    }

    /**
     */
    async syncUpdateUpgradeState(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.syncUpdateUpgradeStateRaw(initOverrides);
        return this.configuration.handleFunction<UpdateUpgradeStatusDto>(response, errorHandlers);
    }

}
